import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  content: {
    display: "flex",
    width: "100%",
    marginBottom: "50px",
    flexDirection: "column",
  },
  btn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    marginTop: 50,
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      marginTop: 20,
    },
  },
  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": { padding: "0px !important" },
    [theme.fn.smallerThan("md")]: {
      width: "95vw",
    },
  },
  mwd: { width: "100%" },
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },
  mt_30: { margin: "30px 0" },
  tabs: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    "& p": { fontSize: "22px", margin: "0" },
  },
  active: { fontWeight: 500, borderBottom: "3px solid var(--app-primary)" },
  clientButtonBar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "1rem",
    [theme.fn.smallerThan("sm")]: {
      flexDirection: "column",
      gap: "10px",
      alignItems: "stretch",
    },
  },
  rightBtns: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",
    marginBottom: 19,
    flexWrap: "wrap",
    [theme.fn.smallerThan("sm")]: {
      justifyContent: "flex-start",
      marginBottom: 10,
    },
  },
  detailBar: {
    display: "flex",
    marginTop: "10px",
    flexDirection: "column",
  },
  tabContainer: {
    display: "flex",
    minWidth: "260px",
    height: "40px",
    [theme.fn.smallerThan("sm")]: {
      minWidth: "unset",
      width: "100%",
    },
  },

  userDetail: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& .detail_box": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "& .image_box": {
        width: "80px",
        height: "80px",
        border: "1px solid var(--app-border)",
        borderRadius: "10px",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      },
      "& h3": { margin: "0", fontSize: "30px", textAlign: "center" },
      "& p": { margin: "0", color: "var(--app-text-muted)", textAlign: "center" },
    },
  },

  monthlyBtn: {
    display: "flex",
    alignItems: "center",
    borderRadius: "50px 0 0 50px",
    background: "var(--app-border)",
    padding: "5px 10px",
    cursor: "pointer",
    "& p": { margin: "0", fontWeight: "600" },
    "& img": { width: "24px", marginRight: "5px" },
  },
  weeklyBtn: {
    display: "flex",
    alignItems: "center",
    background: "var(--app-border)",
    padding: "5px 10px",
    cursor: "pointer",
    "& p": { margin: "0", fontWeight: "600" },
    "& img": { width: "24px", marginRight: "5px" },
  },
  todayBtn: {
    display: "flex",
    alignItems: "center",
    borderRadius: "0 50px 50px 0",
    background: "var(--app-border)",
    padding: "5px 10px",
    cursor: "pointer",
    "& p": { margin: "0", fontWeight: "600" },
    "& img": { width: "24px", marginRight: "5px" },
  },
  users: {
    padding: "20px 30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "10px",
  },
  user: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    "& img": { width: "100%" },
  },
  userBox: {
    width: "82.69px",
    height: "82.69px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "var(--app-border)",
    borderRadius: "100%",
  },
  list: {
    paddingRight: 11,
    marginTop: 10,
    paddingBottom: 26,
    maxHeight: "600px",
    overflowY: "auto",
    "&::-webkit-scrollbar": { width: "6px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--app-border)",
      borderRadius: "3px",
    },
  },
  clientsLabel: {
    textTransform: "capitalize",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: "500",
    color: "var(--app-text-muted)",
    margin: "20px 11px 7px 0px",
  },
  inputStyle: {
    marginRight: 11,
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        paddingBlock: "10px",
        height: "44px",
        color: "var(--app-text)",
      },
      "& .mantine-Select-rightSection svg": { color: "var(--app-text-muted)" },
    },
  },
  item: {
    padding: "14px 12px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    borderBottom: "1px solid var(--app-border)",
    "& p": {
      margin: "0",
      fontSize: "14px",
      fontWeight: "400",
      fontFamily: "Inter",
      color: "var(--app-text)",
    },
  },
  itemActive: {
    backgroundColor: "var(--app-border)",
    "& p": { fontWeight: "bold" },
  },

  scheduleDetail: {
    width: "100%",
    display: "flex",
    gap: "20px",
    [theme.fn.smallerThan("md")]: {
      flexDirection: "column",
      gap: "12px",
    },
  },
  clientPanelWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    flexShrink: 0,
    height: "fit-content",
    [theme.fn.smallerThan("md")]: {
      width: "100%",
      alignItems: "flex-start",
    },
  },
  clientPanelCollapsed: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "14px",
    padding: "10px 6px",
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "16px",
    height: "fit-content",
  },
  clientPanelCollapsedLabel: {
    margin: 0,
    writingMode: "vertical-rl",
    transform: "rotate(180deg)",
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    userSelect: "none",
  },
  clientPanelHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "11px",
    marginBottom: "12px",
    paddingBottom: "12px",
    borderBottom: "1px solid var(--app-border)",
  },
  clientPanelTitle: {
    margin: 0,
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
  },
  collapseToggleRow: {
    marginBottom: "6px",
  },
  collapseToggleBtn: {
    color: "var(--app-text-muted)",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    borderRadius: "6px",
    transition: "background 0.12s ease, border-color 0.12s ease",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
      borderColor: "var(--app-border)",
    },
  },
  marHeaderLabelText: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--app-text-muted)",
    flex: 1,
  },
  marHeaderLabelCellCollapsed: {
    cursor: "pointer",
    padding: "6px",
    justifyContent: "center",
    transition: "background 0.12s ease, border-color 0.12s ease",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
      borderColor: "var(--app-border)",
    },
  },
  scheduleDetailLeft: {
    width: "250px",
    minWidth: "250px",
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "16px",
    padding: "17px 0px 0px 11px",
    height: "fit-content",
    overflow: "hidden",
    [theme.fn.smallerThan("md")]: {
      width: "100%",
      minWidth: "unset",
    },
  },
  scheduleDetailRight: {
    flex: 1,
    minWidth: 0,
    [theme.fn.smallerThan("md")]: {
      width: "100%",
    },
  },
  scheduleDetailRight100: {
    flex: 1,
    minWidth: 0,
    [theme.fn.smallerThan("md")]: {
      width: "100%",
    },
  },

  wrapper: {
    width: "100%",
    overflowX: "auto",
  },
  mainContainer: {
    background: "var(--app-surface)",
    borderRadius: 8,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    padding: "14px 9px 32px 9px",
    [theme.fn.smallerThan("sm")]: {
      padding: "10px 6px 20px 6px",
    },
  },
  dateAndCarousalRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    margin: "14px 8px",
    borderBottom: "1px solid var(--app-border)",
    paddingBottom: "10px",
    "& .dateHdng": {
      fontSize: "18px",
      fontWeight: 600,
      fontFamily: "Inter",
      color: "var(--app-text)",
      textTransform: "uppercase",
    },
    [theme.fn.smallerThan("sm")]: {
      gridTemplateColumns: "1fr",
      gap: "10px",
      "& .dateHdng": { fontSize: "14px" },
    },
  },
  calendarClientInfo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    minWidth: 0,
  },
  calendarClientAvatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "var(--app-border)",
    border: "1px solid var(--app-border)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  calendarClientAvatarInitials: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    lineHeight: 1,
  },
  calendarClientName: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  calendarClientId: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    margin: 0,
  },
  calendarClientNameStack: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  calendarNavCenter: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  calendarRightAction: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },

  dateAndCarousalRowDaily: {
    flexDirection: "column",
  },

  carouselWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    width: "fit-content",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
      justifyContent: "space-between",
    },
  },

  slider: {
    display: "flex",
    alignItems: "stretch",
    padding: "0",
    backgroundColor: "var(--app-bg)",
    border: "1px solid var(--app-border)",
    borderRadius: "6px 6px 0 0",
    width: "fit-content",
    overflowX: "auto",
    "&::-webkit-scrollbar": { display: "none" },
  },
  sliderItem: {
    flexShrink: 0,
    display: "flex",
    alignItems: "stretch",
  },
  calendarScrollWrapper: {
    display: "flex",
    overflowX: "auto",
    "&::-webkit-scrollbar": { display: "none" },
  },
  columnWithHeader: {
    flex: "1 1 0",
    minWidth: "100px",
    display: "flex",
    flexDirection: "column",
    border: "1px solid rgba(90,90,90,0.1)",
    "&:not(:first-of-type)": { borderLeft: "none" },
  },
  columnWithHeaderMonth: {
    flex: "1 1 0",
    minWidth: "100px",
    display: "flex",
    flexDirection: "column",
    "&:first-of-type .monthcard": {
      borderLeft: "1px solid rgba(90,90,90,0.1) !important",
    },
  },
  sliderItemHeader: {
    backgroundColor: "var(--app-bg)",
    borderBottom: "1px solid var(--app-border)",
  },
  columnBody: {
    backgroundColor: "var(--app-surface)",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    flex: 1,
  },
  columnBodyMonth: {
    backgroundColor: "var(--app-surface)",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    flex: 1,
  },
  scheduleBox: {
    width: "100%",
    minHeight: "200px",
    display: "flex",
    flexDirection: "row",
    borderBottom: "1px solid var(--app-border)",
    overflowX: "auto",
    "& > div:nth-of-type(2)": {
      borderLeft: "1px solid rgba(90,90,90,0.1)",
    },
  },
  scheduleBoxForMonth: {
    width: "100%",
    minHeight: "200px",
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    "& > div": {
      borderRight: "1px solid rgba(90,90,90,0.1)",
      borderTop: "1px solid rgba(90,90,90,0.1)",
    },
    "& > div:nth-of-type(1)": {
      borderLeft: "1px solid rgba(90,90,90,0.1)",
    },
    [theme.fn.smallerThan("sm")]: {
      marginTop: "12px",
    },
  },
  column1: {
    width: "45px",
    backgroundColor: "var(--app-primary)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
    "& p": { fontSize: "24px", fontWeight: 700, transform: "rotate(-90deg)" },
  },
  column1Empty: {
    width: "45px",
    backgroundColor: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "10px",
  },
  column: {
    backgroundColor: "var(--app-surface)",
    borderTop: "1px solid rgba(90,90,90,0.1)",
    borderBottom: "1px solid rgba(90,90,90,0.1)",
    borderRight: "1px solid rgba(90,90,90,0.1)",
    display: "flex",
    flexDirection: "column",
    padding: "5px 2px",
    minHeight: "100px",
    minWidth: "100px",
    "&:first-of-type": {
      borderLeft: "1px solid rgba(90,90,90,0.1)",
    },
    [theme.fn.smallerThan("sm")]: {
      minWidth: "80px",
    },
  },
  columnMonth: {
    width: "calc(100% / 7)",
    minWidth: "120px",
    backgroundColor: "var(--app-surface)",
    display: "flex",
    flexDirection: "column",
    [theme.fn.smallerThan("sm")]: {
      minWidth: "90px",
    },
  },
  administerPrnBtnBox: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30px",
    marginBottom: "10px",
  },
  prnButton: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid #6941C6",
    backgroundColor: "#6941C6",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#FFF",
    ":hover": { backgroundColor: "#6941C6", opacity: 0.8 },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 14px",
      height: 38,
    },
  },
  activeWeekToday: {
    background: "var(--app-tint-amber) !important",
  },

  sliderDaily: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    padding: "0px 32px 0px 37px",
    [theme.fn.smallerThan("sm")]: {
      padding: "0px 10px",
      justifyContent: "space-between",
    },
  },
  divider: {
    width: "1px",
    height: "50px",
    backgroundColor: "var(--app-border)",
    marginInline: "2px",
  },
  loadingBox: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "100px 0 0 0",
    [theme.fn.smallerThan("sm")]: {
      padding: "40px 0 0 0",
    },
  },
  cuationsBox: {
    display: "flex",
    justifyContent: "center",
    padding: 15,
  },

  multipleMedBtn: {
    cursor: "pointer",
    color: "var(--app-text)",
    fontSize: "14px",
    fontWeight: 600,
    fontFamily: "Inter",
    display: "flex",
    padding: "10px 16px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface-2)",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    [theme.fn.smallerThan("sm")]: {
      fontSize: "12px",
      padding: "8px 12px",
      width: "100%",
      justifyContent: "center",
    },
  },

  tabsAndBtnBar: {
    padding: "10px 11px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 8,
    backgroundColor: "var(--app-surface)",
    marginBottom: 22,
    flexWrap: "wrap",
    gap: 8,
    [theme.fn.smallerThan("sm")]: {
      padding: "8px",
      marginBottom: 12,
    },
  },
  calendarTabsParent: {
    display: "flex",
    gap: "5px",
    border: "1px solid var(--app-border)",
    background: "var(--app-bg)",
    borderRadius: "4px",
    overflow: "hidden",
    [theme.fn.smallerThan("sm")]: {
      width: "100%",
    },
  },
  calendarTabsBtn: {
    width: "90px",
    cursor: "pointer",
    color: "var(--app-text)",
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.fn.smallerThan("sm")]: {
      flex: 1,
      width: "auto",
      fontSize: 12,
    },
  },
  calendarTabsBtnActive: {
    backgroundColor: "var(--app-surface) !important",
  },
  createReportBtn: {
    padding: "12px 20px",
    borderRadius: "8px",
    border: "1px solid var(--app-primary)",
    backgroundColor: "var(--app-primary)",
    height: 44,
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#FFF",
    ":hover": { backgroundColor: "var(--app-primary)", opacity: 0.8 },
    [theme.fn.smallerThan("sm")]: {
      fontSize: 13,
      padding: "8px 12px",
      height: 38,
    },
  },
  // ── MAR Row-grid (weekly / daily new layout) ──────────────────────────────
  marGridWrapper: {
    overflowX: "auto",
    backgroundColor: "var(--app-surface-2)",
    padding: "10px",
    borderRadius: "8px",
    "&::-webkit-scrollbar": { height: "6px" },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "var(--app-border)",
      borderRadius: "3px",
    },
  },
  marGrid: {
    display: "grid",
    minWidth: "max-content",
    gap: "6px",
  },
  marHeaderRow: {
    display: "contents",
  },
  // Header label cell (top-left corner — "Medication" label)
  marHeaderLabelCell: {
    backgroundColor: "var(--app-bg)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    padding: "6px 8px 6px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "6px",
    position: "sticky",
    left: 0,
    zIndex: 2,
  },
  // Weekly header: each day-of-week column header card
  marHeaderColCell: {
    backgroundColor: "var(--app-bg)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    padding: "8px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
  },
  // Today variant: whole cell gets amber tint
  marHeaderColCellToday: {
    backgroundColor: "var(--app-tint-amber)",
    border: "1px solid var(--app-primary)",
    borderRadius: "8px",
    padding: "8px 8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "2px",
  },
  marHeaderDayName: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    lineHeight: 1.1,
    margin: 0,
  },
  marHeaderDayNameToday: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    color: "#92400E",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    lineHeight: 1.1,
    margin: 0,
  },
  marHeaderDate: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 700,
    color: "var(--app-text)",
    lineHeight: 1.1,
    fontVariantNumeric: "tabular-nums",
    margin: 0,
  },
  marHeaderDateToday: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: 700,
    color: "#92400E",
    lineHeight: 1.1,
    fontVariantNumeric: "tabular-nums",
    margin: 0,
  },
  // Keep for backward compat (no longer used but avoids crashes if referenced)
  marHeaderDateCircle: {},
  // Daily view: each time-slot column header card
  marHeaderSlotTitle: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "0.3px",
    textAlign: "center",
    margin: 0,
  },
  marHeaderSlotTitleCurrent: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    color: "#92400E",
    letterSpacing: "0.3px",
    textAlign: "center",
    margin: 0,
  },
  marDataRow: {
    display: "contents",
  },
  // Medication label cell (left column, sticky)
  marLabelCell: {
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "8px",
    padding: "10px 12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "4px",
    minWidth: "260px",
    maxWidth: "260px",
    overflow: "hidden",
    position: "sticky",
    left: 0,
    zIndex: 1,
    cursor: "pointer",
    transition: "border-color 0.14s ease",
    "&:hover": {
      borderColor: "var(--app-text)",
    },
  },
  marLabelCellCollapsed: {
    minWidth: "36px",
    maxWidth: "36px",
    width: "36px",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px",
    cursor: "pointer",
    overflow: "hidden",
    gap: 0,
  },
  marLabelTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
  },
  marLabelPillIconWrap: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "6px",
    flexShrink: 0,
  },
  marLabelPillIconWrapNarcotic: {
    backgroundColor: "#FEE2E2",
    color: "#B91C1C",
  },
  marLabelPillIconWrapNormal: {
    backgroundColor: "#FEF3C7",
    color: "#92400E",
  },
  marLabelMedName: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "-0.005em",
    lineHeight: 1.25,
    margin: 0,
    wordBreak: "break-word",
    flex: 1,
  },
  marLabelStrength: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 500,
    color: "var(--app-text-muted)",
    margin: 0,
  },
  marLabelBadgeRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    flexWrap: "wrap",
    marginTop: "2px",
  },
  marLabelFreq: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 700,
    color: "var(--app-on-primary)",
    backgroundColor: "var(--app-primary)",
    border: "1px solid var(--app-primary)",
    borderRadius: "4px",
    padding: "2px 8px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    width: "fit-content",
    margin: 0,
  },
  marLabelFreqPrn: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 700,
    color: "#FFFFFF",
    backgroundColor: "#6941C6",
    border: "1px solid #6941C6",
    borderRadius: "4px",
    padding: "2px 8px",
    letterSpacing: "0.4px",
    textTransform: "uppercase",
    width: "fit-content",
    margin: 0,
  },
  marLabelTimeSlot: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    color: "var(--app-text-muted)",
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "normal",
    wordBreak: "break-word",
    margin: 0,
  },
  marLabelSig: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    fontStyle: "italic",
    lineHeight: 1.4,
    margin: 0,
    marginTop: "2px",
    paddingTop: "4px",
    borderTop: "1px dashed var(--app-border)",
  },
  marLabelMedInfo: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    lineHeight: 1.4,
    margin: 0,
    marginTop: "2px",
    paddingTop: "4px",
    borderTop: "1px dashed var(--app-border)",
  },
  marNarcoticBadge: {
    display: "inline-block",
    backgroundColor: "#FEE2E2",
    color: "#B91C1C",
    border: "1px solid #FECACA",
    fontSize: "9px",
    fontWeight: 700,
    padding: "1px 7px",
    borderRadius: "999px",
    fontFamily: "Inter",
    letterSpacing: "0.4px",
    width: "fit-content",
  },
  // Status tinted cell (status bg + border, rounded card)
  marTintedCell: {
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "column",
    padding: "10px 10px 12px",
    cursor: "pointer",
    minHeight: "138px",
    transition: "border-color 0.14s ease, box-shadow 0.14s ease",
    "&:hover": {
      boxShadow: "0 1px 3px rgba(16,24,40,0.08)",
    },
  },
  marTintedCellInner: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    flex: 1,
    justifyContent: "center",
  },
  marTintedCellPillRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    paddingBottom: "8px",
  },
  marTintedCellDivider: {
    width: "100%",
    height: 0,
    borderTop: "1px solid var(--app-border)",
    margin: 0,
  },
  marTintedCellBody: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "6px",
    paddingTop: "10px",
    paddingBottom: "6px",
    width: "100%",
  },
  marCellNoAdmin: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    gap: "4px",
  },
  // Status pill inside the tinted cell
  marCellStatusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
    padding: "3px 10px 3px 4px",
    borderRadius: "999px",
    fontSize: "10px",
    fontWeight: 700,
    letterSpacing: "0.3px",
    textTransform: "uppercase",
    color: "#FFFFFF",
    fontFamily: "Inter",
    maxWidth: "100%",
  },
  marCellStatusPillIcon: {
    width: "14px",
    height: "14px",
    borderRadius: "999px",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  // Staff tile inside tinted cell
  marCellAdminTile: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "4px 6px",
    borderRadius: "6px",
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    cursor: "pointer",
    transition: "background 0.12s ease, border-color 0.12s ease",
    "&:hover": {
      borderColor: "var(--app-text)",
    },
  },
  marCellAdminTime: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 700,
    fontVariantNumeric: "tabular-nums",
    whiteSpace: "nowrap",
    flex: 1,
    textAlign: "left",
    margin: 0,
  },
  marCellInitialsAvatar: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: "26px",
    height: "26px",
    borderRadius: "999px",
    fontWeight: 800,
    fontSize: "10px",
    letterSpacing: "0.4px",
    fontFamily: "Inter",
    flexShrink: 0,
    borderWidth: "2px",
    borderStyle: "solid",
  },
  marCellStatusDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  marCellStatusText: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 600,
    textAlign: "center",
    margin: 0,
  },
  marCellTimeText: {
    fontFamily: "Inter",
    fontSize: "9px",
    fontWeight: 400,
    color: "var(--app-text-muted)",
    margin: 0,
    textAlign: "center",
  },
  // Empty cell (no medication in this slot)
  marEmptyCell: {
    borderRadius: "8px",
    border: "1px dashed var(--app-border)",
    backgroundColor: "var(--app-surface)",
    minHeight: "138px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "var(--app-text-muted)",
    fontSize: "16px",
    fontWeight: 500,
  },
  marCollapseToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: "8px",
  },
  // ─────────────────────────────────────────────────────────────────────────

  monthPicker: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        height: "44px",
        color: "var(--app-text)",
        minWidth: "150px",
        [theme.fn.smallerThan("sm")]: {
          minWidth: "120px",
          height: "38px",
        },
      },
      "& .mantine-MonthPickerInput-icon svg": { color: "var(--app-text-muted)" },
    },
  },
}));

export default useStyles;
